module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-126.07352401.svg";